import { useEffect, useState } from 'react';
import { t } from '@lingui/macro';
import { Dashboard } from 'components/Dashboard/Dashboard';
import { DashboardProvider } from 'components/Dashboard/Dashboard.context';
import { FirstAppModal } from 'components/PortalTours/FirstAppModal/FirstAppModal';
import { useTutorials } from 'components/PortalTours/hooks/useTutorials.hook';
import { useSearchParams } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import { useTrackingIdentify } from 'utils/tracking/tracking.hooks';
import { BaseLayout } from '../components/Layout/BaseLayout/BaseLayout';

import styles from './index.module.css';

export const HomePage = () => {
  useTrackingIdentify();

  const [searchParams] = useSearchParams();
  const hasPortalToursCookie = Boolean(getCookie('showPortalTours'));
  const hasShowDashboardTourParams = searchParams.get('_showTour') === 'true';
  const { triggerDashboardTour, triggerNavigationTour, shouldShowTour } =
    useTutorials(!hasShowDashboardTourParams);

  const [isFirstAppModalDismissed, setIsFirstAppModalDismissed] =
    useState(false);

  const showFirstAppModal =
    shouldShowTour.firstApplication &&
    !isFirstAppModalDismissed &&
    !hasShowDashboardTourParams &&
    !shouldShowTour.newUser;

  useEffect(() => {
    if (shouldShowTour.newUser && hasPortalToursCookie) {
      triggerNavigationTour();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowTour.newUser, hasPortalToursCookie]);

  useEffect(() => {
    if (
      hasShowDashboardTourParams &&
      !shouldShowTour.newUser &&
      hasPortalToursCookie
    ) {
      triggerDashboardTour();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    hasPortalToursCookie,
    hasShowDashboardTourParams,
    shouldShowTour.newUser,
  ]);

  return (
    <BaseLayout
      pageTitle={t`Dashboard | Introducer Portal`}
      className={styles.dashboardLayout}
      showDEFooter
    >
      <DashboardProvider>
        <Dashboard />
      </DashboardProvider>
      {/* TODO: add flag once BE has been implemented to determine if an app has been created */}
      {showFirstAppModal && hasPortalToursCookie && (
        <FirstAppModal
          triggerTour={triggerDashboardTour}
          showModal={showFirstAppModal}
          closeModal={() => setIsFirstAppModalDismissed(true)}
        />
      )}
    </BaseLayout>
  );
};
